<template>
	<div >
		<div class="row">
			<div class="col-12">
				<div v-if="!newLot" class="lot-num">
					<label>Lot Number</label>
					<p>{{values.num}}</p>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-4">
				<label>Start Time</label>
				<vue-timepicker v-model="values.start_time" format="HH:mm"></vue-timepicker>
			</div>
			<div class="col-4">
				<label>End Time</label>
				<vue-timepicker v-model="values.end_time" format="HH:mm"></vue-timepicker>
			</div>
		</div>
		<div class="row">
			<div class="col-12 text-right">
				<button class="button-action" @click="save">{{ newLot ? 'Add Lot' : 'Save Changes' }}</button>
			</div>
		</div>
	</div>
</template>

<script>
import InputText from '../Form/InputText.vue'
import VueTimepicker from 'vue2-timepicker'

export default {
	components: {
		InputText,
		VueTimepicker
	},
	props: [
		'lot',
	],
	data() {
		return {
			values: {},
			errors: {},
			requiredFields: ['start_time', 'end_time'],
			newLot: true
		}
	},
	methods: {
		formIsValid() {
			let validForm = true

			this.errors = {}

			this.requiredFields.forEach(field => {
				if(!this.values.hasOwnProperty(field) || this.values[field] == '') {
					this.errors[field] = 'This field is required.'
					validForm = false
				}
			})

			return validForm
		},
		save() {
			if(!this.formIsValid()) {
				this.$store.dispatch('app/addAlert', {
					type: 'error',
					message: 'Form error - please check and re-submit',
					timeout: 3000
				})
				return
			}

			const action = this.newLot ? 'create' : 'update'
			const postActionDescription = this.newLot ? 'Added' : 'Updated'

			if(typeof this.values.start_time === 'object') {
				this.values.start_time = `${this.values.start_time.HH}` + ':' + `${this.values.start_time.mm}`
			}
			
			if(typeof this.values.end_time === 'object') {
				this.values.end_time = `${this.values.end_time.HH}` + ':' + `${this.values.end_time.mm}`
			}
			
			this.$store.commit('app/setLoading', true)
			this.$store.dispatch(`lots/${action}`, this.values)
			.then(() => {
				this.$store.commit('app/setLoading', false);
				this.$store.dispatch('app/addAlert', {
					type: 'success',
					message: `Lot ${postActionDescription}`,
					timeout: 3000
				})
				this.$emit('close');
			})
			.catch(err => {
				this.$store.commit('app/setLoading', false)
				this.$store.dispatch('app/addAlert', {
					type: 'error',
					message: 'An Error occurred, please try later',
					timeout: 3000
				})
			})

		}
	},
	mounted() {
		if(this.lot) {
			this.values = JSON.parse(JSON.stringify(this.lot))
			this.newLot = false
		}
	}
}
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/Lot/Form.vue